function mapArrayToFormData(formData: FormData, array: Array<any>, key: string): void {
	let i = 0;
	for (let value of array) {
		if (typeof value === 'object' && !(value instanceof File)) {
			mapObjectToFormData(formData, value, `${key}[${i}]`);
		} else {
			formData.append(`${key}`, value);
		}
		i++;
	}
}
function mapObjectToFormData(
	formData: FormData,
	obj: { [key: string]: any },
	key: string
): void {
	for (let field in obj) {
		formData.append(`${key}[${field}]`, obj[field]);
	}
}

export function convertToFormData(data: { [key: string]: any }): FormData {
	const formData = new FormData();
	for (let key in data) {
		if (Array.isArray(data[key])) {
			mapArrayToFormData(formData, data[key], key);
		} else if (typeof data[key] === 'object') {
			mapObjectToFormData(formData, data, key);
		} else {
			formData.append(key, data[key]);
		}
	}
	return formData;
}
